import React from "react";
import styles from "../CommercialTransactions/CommercialTransactions.module.css";
import Footer from "../Footer/Footer";
import { useNavigate } from "react-router-dom";
const CommercialTransactions = () => {
  const navigate = useNavigate();
  return (
    <div>
      <div className="container d-block">
        <div className={`${styles.commercial}`}>
          <div className={`${styles.information}`}>
            <div className={styles.commercial1_header}>
              <h3>特定商取引法に基づく表記</h3>
              <div
                onClick={() => {
                  navigate(-1);
                }}
              >
                <ion-icon name="close"></ion-icon>
              </div>
            </div>
            <div className={styles.make_this_bold}>
              <p className="mt-5">
                販売業者名 株式会社ブルースカイ <br />
                運営統括責任者 貞末真吾 <br />
                問い合わせ先 〒810-0045 福岡市中央区今川2-1-17鳥飼八幡宮境内{" "}
                <br />
                電話：092-406-2645 <br />
                URL https://acestudio.jp/ <br />
                メールアドレス info@acestudio.jp <br />
              </p>
            </div>
            <p className="mt-5">
              <div className={styles.make_this_bold}>
                ー 販売数量の制限等特別な販売条件
              </div>
              <br />
              ・販売価格：すべての商品は税込金額で表示いたします。 <br />
              ・商品以外の必要代金 配送料 :
              商品合計11,000円(税込)以上お買い上げで 送料無料。 <br />
              11,000円(税込)未満の場合は配送料880円(税込) <br />
            </p>

            <p className="mt-5">
              <div className={styles.make_this_bold}>ー お支払い方法</div>{" "}
              <br />
              ・クレジットカード決済・PayPay・楽天Pay・AmazonPayをご利用いただけます。
              <br />
              　ソフトバンクペイメントサービスの決済システムを利用しております。
              <br />
              　カード承認等は暗号化通信にて行われますのでご安心ください。{" "}
              <br />
              　ご利用可能カード : VISA Master ダイナース ディスカバー JCB AMEX{" "}
              <br />
            </p>
            <p className="mt-5">
              ・銀行振り込み <br />
              　ご入金はご注文確認メールを送信後、7日以内にお振込をお願いしております。
              <br />
              　7日を過ぎても入金が確認できない際はキャンセル扱いとさせていただきます。
              <br />
              　尚、振込手数料はお客様のご負担になりますのでご了承ください。
              <br />
            </p>
            <p className="mt-5">
              <div className={styles.make_this_bold}>
                ー サービス利用開始時期{" "}
              </div>
              <br />
              撮影データの編集・確認を行いデータの準備が整ったのち My
              Aceサービスをご利用いただけます。
              <br />
              通常、撮影の翌日からご利用いただけます。出張プラン・ニューボーンプランなど編集にお時間をいただく撮影の場合、
              <br />
              撮影後１週間以内にご利用可能です。
              <br />
              ダウンロード期限は、データの提供後90日以内です。期限を過ぎた場合、再度データをご購入ください。
              <br />
            </p>
            <p className="mt-5">
              <div className={styles.make_this_bold}>ー 商品引渡し時期</div>{" "}
              <br />
              ・フォトグッズ <br />
              商品をご注文後、写真・文字入れ等が全て完了してから約1ヶ月前後でのお渡しとなります。
              <br />
              ※ご注文状況・ご注文内容によっては、1ヶ月以上の納期をいただく場合もございます。
              <br />
              ※交通事情、天候等の諸事情により、商品到着予定日よりも2~3日遅れて届く場合もありますのでご了承ください。
              <br />
            </p>
            <p className="mt-5">
              <div className={styles.make_this_bold}>ー 返品・交換について</div>{" "}
              <br />
              お客様のご都合による返品、交換はいかなる場合においても応じられません。
              <br />
              ご注文翌日以降の注文内容の変更、キャンセルはお受けすることができません。{" "}
              <br />
              ダウンロードした撮影データが破損している場合、必ずお電話(092-406-2645)またはオフィシャルLINEにて{" "}
              <br />
              ご連絡をお願いいたします。イメージが異なるなどの理由での再撮影は応じることができませんのでご了承ください。{" "}
              <br />
            </p>
            <p className="mt-5">
              <div className={styles.make_this_bold}>ー 商品不良について </div>
              <br />
              下記のいずれかに該当する商品不良の場合は返品・交換いたします。
              <br />
              商品到着後１週間以内に必ずお電話(092-406-2645)またはオフィシャルLINEにて当社へご連絡ください。
              <br />
              ・商品の破損 <br /> ・ご注文と異なった商品 <br />
              それ以外の理由による、お取替え、ご返品には応じることはできませんのでご了承ください。{" "}
              <br />
              返品期限は、商品到着から７日以内です。商品の破損・不良による返送の場合、送料は当社で負担させていただきます。
              <br />
              返品・交換の際は、新商品と引き換えに返送用袋を同封いたします。
              <br />
              「ゆうパック」または「ヤマト運輸」の「着払い」にてお手続きいただきますようお願いいたします。
              <br />
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommercialTransactions;
